import { type TherapistType } from '../../types/TherapistStateType'

export type HandleReserveEventOptions = {
  readonly therapist: TherapistType
  readonly slot: ReserveSlotType
  readonly userSubscriptionId?: number
  readonly companyEventQuotaId?: number
  readonly paymentMethod?: string
  readonly voucherCode?: string
  readonly isInstantTherapy?: boolean
  readonly isCounselling?: boolean
  readonly counsellingSessionId?: number
  readonly membershipId?: number
}

export type ReserveSlotType = {
  readonly startDate: string
  readonly endDate: string
  readonly serviceId: number
  readonly id?: number
  readonly counsellingSessionId?: number
  readonly status?: number
}

export enum PriorityPaymentMethodType {
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
}
